interface SutraMarkProps {
  className?: string;
  /** Unique id suffix so multiple instances don't collide on the gradient def. */
  idSuffix?: string;
}

/**
 * Sutra brand mark: an open ring (the path, never closed) gathered around
 * one bindu (the single reality the many forms circle).
 * No deity imagery, sect-neutral.
 */
export const SutraMark = ({ className, idSuffix = "default" }: SutraMarkProps) => {
  const gradId = `sutra-mark-${idSuffix}`;
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#c5532b" />
          <stop offset="1" stopColor="#e8a13c" />
        </linearGradient>
      </defs>
      <path
        d="M42,14.68 A20,20 0 1 1 22,14.68"
        fill="none"
        stroke={`url(#${gradId})`}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="32" cy="32" r="5" fill="#c5532b" />
    </svg>
  );
};

export default SutraMark;
